export default __webpack_public_path__ + "static/media/P941_CoC.2eee0480.pdf";